import React, { useState } from "react";
import { Button } from "../common/Button";
import { useStepData } from "../../hooks/useStepData";
import { useFunnelNavigation } from "../../hooks/useFunnelNavigation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { InfoBox } from "../common/InfoBox";
import { StepHeader } from "../common/StepHeader";

export function BirthdayStep({ config }) {
  const { data, updateStepData } = useStepData(config.field);
  const { nextStep } = useFunnelNavigation();
  const [date, setDate] = useState(data || "");

  const [startDate, setStartDate] = useState(data ? new Date(data) : null);

  const handleNext = () => {
    if (isValidDate(date)) {
      updateStepData(date);
      nextStep();
    }
  };

  const isValidDate = (dateString) => {
    const selectedDate = new Date(dateString);
    const today = new Date();
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 100); // 100 years ago
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 13); // 13 years ago

    return selectedDate >= minDate && selectedDate <= maxDate;
  };

  return (
    <div className="px-4">
      <StepHeader
        title={config.title}
        subtitle={config.subtitle}
        order={config.headerOrder}
      />

      <div className="space-y-6">
        <div className="relative">
          <DatePicker
            selected={startDate}
            onChange={(date) => {
              setStartDate(date);
              setDate(date.toISOString().split("T")[0]);
            }}
            dateFormat="MMMM d, yyyy"
            openToDate={new Date(2000, 0, 1)}
            showMonthDropdown
            showYearDropdown
            scrollableYearDropdown
            disabledKeyboardNavigation
            yearDropdownItemNumber={100}
            placeholderText="Choose date of birth"
            className="w-full px-4 py-4 pr-12 rounded-xl border border-gray-300
                           text-gray-700 text-lg font-medium"
            maxDate={new Date()}
            minDate={
              new Date(new Date().setFullYear(new Date().getFullYear() - 100))
            }
            withPortal
          />
          {/* Custom calendar icon */}
          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <img
              src="/calendar.svg"
              alt="calendar"
              className="w-6 h-6 text-gray-400"
            />
          </div>
        </div>
        {/* Info box with icon */}
        <InfoBox
          icon="question"
          title="We use your age for personalization purposes only."
          text={config.description}
        />
      </div>

      {date && (
        <Button
          onClick={handleNext}
          className="w-full mt-6 py-4"
          disabled={!isValidDate(date)}
        >
          Next
        </Button>
      )}
    </div>
  );
}
